import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormattedDatePipe } from '../../pipes/formatted-date/formatted-date.pipe';
import { OwlDatepickerCustomizer } from '../../services/owl-datepicker-customizer.service';

@Component({
  selector: 'app-edit-transaction-date',
  templateUrl: './edit-transaction-date.component.html',
  styleUrls: ['./edit-transaction-date.component.scss']
})
export class EditTransactionDateComponent implements OnDestroy {

  @Input()
  set date(value) {
    if(value) {
      this.setDate(value);
    }
  }

  @Output() dateSelected: EventEmitter<Date> = new EventEmitter();

  public isOpen: boolean;
  public dateString: string;
  public dateTimeValue:Date;

  private setButtonNativeElement: Element;
  private setButtonClickListener!: EventListener;

  @ViewChild('datepickerInstance') datepickerInstance;
  
  constructor(private formattedDatePipe: FormattedDatePipe, private owlCustomizer: OwlDatepickerCustomizer) { }

  // datepickerChange(dateObj: any): void {
  //   this.dateString = this.formattedDatePipe.transform(dateObj.value, 'MMM d a, HH:mm yyyy');
  //   this.dateTimeValue = dateObj.value;
  //   this.dateSelected.emit(this.dateTimeValue);
  // }

  datepickerClosed(): void {
    this.isOpen = false;
  }

  onEditIconClick(): void {
    this.isOpen = true;
    setTimeout(() => {
      this.owlCustomizer.customizeOwlDateTimer();
      //there's no built-in output event in owl datepicker nuget for set button click
      this.setButtonClickListener = this.onSetButtonClick.bind(this);
      this.setButtonNativeElement = document.querySelectorAll('.owl-dt-container-row.owl-dt-container-buttons button')[1];
      this.setButtonNativeElement?.addEventListener('click', this.setButtonClickListener, {capture: true});
     });
  }

  private onSetButtonClick(ev: PointerEvent) {
    ev.stopImmediatePropagation();
    this.dateSelected.emit(this.datepickerInstance?._selected);
  }

  close(date?: Date) {
    if(date) {
      this.setDate(date);
    }

    this.datepickerInstance?.close();
  }

  open() {
    this.datepickerInstance?.open();
  }

  now(): Date {
    return new Date();
  }

  private setDate(date: Date) {
    this.dateString = this.formattedDatePipe.transform(date, 'MMM d a, HH:mm yyyy');
    this.dateTimeValue = date;
  }

  ngOnDestroy(): void {
    this.setButtonNativeElement?.removeEventListener('click', this.setButtonClickListener);
  }

}
